import Vue from 'vue'
import VueRouter from 'vue-router'

import createwaiting from '../views/reserve/createwaiting.vue'
Vue.use(VueRouter)
const routes = [
	{ path: '/', name: 'notfound', component: () => import('../views/errorpage/NotFound.vue') },
	{ path: '/QRend', name: 'QRend', component: () => import('../views/errorpage/QRend.vue') },
	{ path: '*', name: 'notfound', component: () => import('../views/errorpage/NotFound.vue') },
	{
		path: '/reserve_login/:code/:qrcode',
		name: 'reserve_login',
		component: () => import(/* webpackChunkName: "reserve_login" */ '../views/cuslike/reserve_login.vue'),
	},
	{
		path: '/reserve_page/:code/:qrcode',
		name: 'reserve_page',
		component: () => import(/* webpackChunkName: "reserve_page" */ '../views/cuslike/reserve_page.vue'),
	},
	/// cancelwaiting
	{
		path: '/cancelwaiting/:groupcode/:code/:phone',
		name: 'cancelwaiting',
		component: () => import(/* webpackChunkName: "cancelwaiting" */ '../views/reserve/cancelwaiting.vue'),
	},
	{
		path: '/cancelwaiting/:code/:phone',
		name: 'cancelwaiting',
		component: () => import(/* webpackChunkName: "cancelwaiting" */ '../views/reserve/cancelwaiting.vue'),
	},
	{
		path: '/COUNSELORPAGE/:code/:biz',
		name: 'COUNSELORPAGE',
		component: () => import(/* webpackChunkName: "COUNSELORPAGE" */ '../views/counselor/counselor.vue'),
	},
	{
		path: '/counselorlogin/:code',
		name: 'counselorlogin',
		component: () => import(/* webpackChunkName: "counselorlogin" */ '../views/counselor/counselorlogin.vue'),
	},

	{
		path: '/board/:code',
		name: 'board',
		component: () => import(/* webpackChunkName: "board" */ '../views/counselor/board.vue'),
	},
	/// createwaiting
	{
		path: '/createwaiting/:groupcode/:code/:phone',
		name: 'createwaiting',
		component: createwaiting,
	},
	{
		path: '/createwaiting/:code/:phone',
		name: 'createwaiting',
		component: createwaiting,
	},
	{
		path: '/reserve_day/:code',
		name: 'reserveday',
		component: () => import(/* webpackChunkName: "reserveday" */ '../views/reserve/reserve_day.vue'),
		meta: { title: '방문예약' },
	},
	{
		path: '/waitingCheck/:groupcode/:code/:phone',
		name: 'waitingCheck',
		component: () => import(/* webpackChunkName: "waitingCheck" */ '../views/reserve/waitingCheck.vue'),
	},
	{
		path: '/waitingCheck/:code/:phone',
		name: 'waitingCheck',
		component: () => import(/* webpackChunkName: "waitingCheck" */ '../views/reserve/waitingCheck.vue'),
	},
	{
		path: '/reserve_direct/:code',
		name: 'reservedirect',
		component: () => import(/* webpackChunkName: "reservedirect" */ '../views/reserve/reserve_direct.vue'),
	},
	{
		path: '/reserve_waiting/:code',
		name: 'reserve_waiting',
		component: () => import(/* webpackChunkName: "reservedirect" */ '../views/reserve/reserve_waiting.vue'),
	},
	{
		path: '/reserve_event/:code',
		name: 'reserve_event',
		component: () => import(/* webpackChunkName: "reserve_visit" */ '../views/reserve/reserve_event.vue'),
	},
	{
		path: '/reserve_visit/:code',
		name: 'reservevisit',
		component: () => import(/* webpackChunkName: "reserve_visit" */ '../views/reserve/reserve_visit.vue'),
	},
	// {
	// 	path: '/reserve_keypad/:code',
	// 	name: 'reserve_keypad',
	// 	component: () => import(/* webpackChunkName: "reserve_keypad" */ '../views/reserve/reserve_keypad.vue'),
	// },
	{
		path: '/reserve_keypad_event/:code',
		name: 'reserve_keypad_event',
		component: () => import(/* webpackChunkName: "reserve_keypad_event" */ '../views/reserve/reserve_keypad_event.vue'),
	},
	{
		path: '/reserve_keypad_event2/:code',
		name: 'reserve_keypad_event2',
		component: () => import(/* webpackChunkName: "reserve_keypad_event2" */ '../views/reserve/reserve_keypad_event2.vue'),
	},
	{
		path: '/reserve_keypad_event3/:code',
		name: 'reserve_keypad_event3',
		component: () => import(/* webpackChunkName: "reserve_keypad_event3" */ '../views/reserve/reserve_keypad_event3.vue'),
	},
	{
		path: '/reserve_keypad_event4/:code',
		name: 'reserve_keypad_event4',
		component: () => import(/* webpackChunkName: "reserve_keypad_event4" */ '../views/reserve/reserve_keypad_event4.vue'),
	},
	// {
	// 	path: '/reserve_event_keypad/:code',
	// 	name: 'reserve_event_keypad',
	// 	component: () => import(/* webpackChunkName: "reserve_event_keypad" */ '../views/reserve/reserve_event_keypad.vue'),
	// },
	{
		path: '/reserve_keypad2_event/:code',
		name: 'reserve_keypad2_event',
		component: () => import(/* webpackChunkName: "reserve_keypad2_event" */ '../views/reserve/reserve_keypad2_event.vue'),
	},
	{
		path: '/visitReserve/:code/:name/:phone',
		name: 'visitReserve',
		component: () => import(/* webpackChunkName: "reserve_visitReserve" */ '../views/reserve/reserve_visitReserve.vue'),
	},
	{
		path: '/reserve_visit/:code/:subCode',
		name: 'reservevisit',
		component: () => import(/* webpackChunkName: "reserve_visit" */ '../views/reserve/reserve_visit.vue'),
	},

	{
		path: '/visit/:code/:id/:phone',
		name: 'visitUploadModal',
		component: () => import(/* webpackChunkName: "visitUploadModal" */ '../components/dialog/visitUploadModal.vue'),
	},
	{
		path: '/reserveLogin/:code',
		name: 'reserveLogin',
		component: () => import(/* webpackChunkName: "reserveAdmin" */ '../views/reserveusersAdmin/reserveLogin.vue'),
	},
	{
		path: '/reserveAdmin/:code',
		name: 'reserveAdmin',
		meta: { requiresAuth: true },
		component: () => import(/* webpackChunkName: "reserveAdmin" */ '../views/reserveusersAdmin/reserveAdmin.vue'),
	},
	{
		path: '/reserveCheck/:groupcode/:code/:phone',
		name: 'reserveCheck',
		component: () => import(/* webpackChunkName: "waitingCheck" */ '../views/reserveusersAdmin/reserveCheck.vue'),
	},
	{
		path: '/reserveBoard/:code',
		name: 'board',
		component: () => import(/* webpackChunkName: "reserveBoard" */ '../views/reserveusersAdmin/reserveBoard.vue'),
	},
	{
		path: '/visit/:code/:id/:phone',
		name: 'visitUploadModal',
		component: () => import(/* webpackChunkName: "visitUploadModal" */ '../components/dialog/visitUploadModal.vue'),
	},
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
	scrollBehavior: () => {
		return { x: 0, y: 0 }
	},
})

export default router
